/**
 * 店铺来源标记（store_code）：
 * 用户扫描店铺二维码进入时，URL 携带 ?sid=<store_code>（如 https://host/?sid=A3f9Kx2m#/）。
 * 首次落地时保存到 localStorage，之后所有 API 请求由 axios 拦截器自动附带 X-Store-Code 头，
 * 后端据此把行为日志归属到对应店铺。
 */
const STORE_CODE_KEY = 'store_code'

/**
 * 从当前 URL 捕获 ?sid= 并持久化（以最后一次扫码入口为准）。
 * hash 路由下 query 位于 # 之前，location.search 可正常读取。
 */
export function captureStoreCodeFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search)
    const sid = params.get('sid')
    if (sid) {
      localStorage.setItem(STORE_CODE_KEY, sid)
    }
  } catch (e) {
    console.warn('capture store code failed:', e)
  }
}

export function getStoreCode() {
  return localStorage.getItem(STORE_CODE_KEY)
}
